var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-0"},[(((_vm.lesson.video !== null) && (typeof _vm.lesson !== 'undefined') &&(typeof _vm.lesson.video !== 'undefined')))?_c('div',{staticClass:"row",staticStyle:{"text-align":"center"}},[_c('youtube',{ref:"youtube",staticClass:"col-md-12",attrs:{"video-id":_vm.lesson.video}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }